module.exports = __webpack_public_path__ + "img/IMG-20200722-WA0007.34dc0b8c.jpg";